import { Button, Card, Modal, Select, Tag } from 'antd';
import { useToast } from 'components/Toast';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  selectListCourses,
  selectListCoursesBase,
  selectListPeriod,
  selectListPeriodId
} from 'store/common/shared/selectors';
import { RESPONSE_MESSAGE } from 'store/createReview/constants/createReview.constants';
import { CreateReviewHttp } from 'store/createReview/services/createReview.http';
import styled from 'styled-components';
import _ from 'lodash';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { DownOutlined } from '@ant-design/icons';

const Container = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  margin-bottom: 10px;
`;

const StyleSelectPeriod: typeof Select = styled(Select)`
  height: 40px;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  border-radius: 5px;
  &:hover > div {
    cursor: pointer !important;
  }
  & .ant-select-selector {
    height: 40px !important;
    border-radius: 5px !important;
    & .ant-select-selection-search {
        height: 40px !important;
     }
     & .ant-select-selection-search-input {
        height: 40px !important;
     }
     & .ant-select-selection-item {
        line-height: 40px !important;
     }
     & .ant-select-selection-placeholder {
        line-height: 40px !important;
     }
    }
    
}
` as any;
const IconDropdown = styled.span`
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  display: flex;
  align-items: center;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  text-align: center;
  pointer-events: none;
`;

const StyleSelectCourse: typeof Select = styled(Select)`
  height: 40px;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  border-radius: 5px;
  & .ant-select-selector {
    height: 40px !important;
    border-radius: 5px !important;
    & .ant-select-selection-search {
        height: 40px !important;
     }
     & .ant-select-selection-search-input {
        height: 40px !important;
     }
     & .ant-select-selection-item {
        line-height: 40px !important;
     }
     & .ant-select-selection-placeholder {
        line-height: 40px !important;
     }
    }
  }
` as any;
interface IModal {
  isOpen: boolean;
  handleCancel: () => void;
  title?: string;
  id?: string;
  handleRefresh: () => void;
}

const { Option } = Select;
function ModalCloneReview({ isOpen, title, handleCancel, handleRefresh, id }: IModal) {
  const toast = useToast();
  const listCourse: any = useSelector(selectListCourses);
  const listCourseBase: any = useSelector(selectListCoursesBase);
  const listPeriod: any = useSelector(selectListPeriod);
  const [yearSchool, setYearSchool] = useState<string>('');
  const [titleReview, setTitleReview] = useState<string>('');
  const [period, setPeriod] = useState<string[]>([]);
  const [evaluationId, setEvaluationId] = useState<string>('');

  const createReviewHttp = new CreateReviewHttp();

  useEffect(() => {
    getDetailReview();
  }, []);

  const getDetailReview = () => {
    createReviewHttp.detailReview(id).then((res) => {
      if (res.ok && res.status === 200) {
        const { data } = res.data;
        setTitleReview(data.evaluation_detail.evaluation.title);
        setYearSchool(data.evaluation_detail.evaluation.course_id);
        setPeriod([...period, ...data.evaluation_detail.evaluation.period_ids]);
        setEvaluationId(data.evaluation_detail.evaluation.id);
      } else {
        // getDetailReview();
      }
    });
  };

  const onSelectYear = (value: string): void => {
    setYearSchool(value);
  };

  const onChangeValue = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setTitleReview((e.target as HTMLInputElement).value);
  };

  const onSelectPeriod = (value: string[]): void => {
    setPeriod(value);
  };
  const handleSubmit = () => {
    if (titleReview === '' || yearSchool === '' || period.length === 0) {
      toast?.pushWarning(RESPONSE_MESSAGE.WARN.ADD_REVIEW_SUCCESS);
      return;
    }
    const request = {
      evaluationId: evaluationId,
      courseId: parseInt(yearSchool),
      periodId: period ? period.map((item) => Number(item)) : [],
      titleReview: titleReview
    };
    createReviewHttp.copyReview(request).then((res) => {
      if (res.ok && res.status === 200) {
        toast?.pushSuccess(RESPONSE_MESSAGE.SUCCESS.COPY_REVIEW_SUCCESS);
        handleCancel();
        handleRefresh();
      } else {
        toast?.pushError(RESPONSE_MESSAGE.FAIL.COPY_REVIEW_FAIL);
      }
    });
  };
  const tagRender = (props: CustomTagProps) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3, fontSize: '14px', fontWeight: '400', lineHeight: '25px' }}>
        {label}
      </Tag>
    );
  };
  return (
    <Modal
      title="Copy đánh giá"
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      width={800}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>,
        <Button key="submit" size="large" type="primary" onClick={handleSubmit}>
          Tạo nhân bản
        </Button>
      ]}>
      <Container>
        <Card>
          <div className="mb-15">
            <label htmlFor="" className="font-bold mb-10 block">
              Tên đánh giá
            </label>
            <input
              type="text"
              className="w-full h-44 font-montserrat border-1 text-15 placeholder:text-999 border-solid border-cbce shadow-lg rounded-5 px-15"
              onChange={onChangeValue}
              value={titleReview}
            />
          </div>
          <div className="grid sm:grid-2 gap-15 sm:gap-20">
            <div>
              <label htmlFor="" className="font-bold mb-10 block">
                Năm học
              </label>
              <div className="relative">
                <StyleSelectCourse
                  style={{ width: 350, height: 40 }}
                  placeholder="Chọn năm học"
                  value={yearSchool}
                  onChange={onSelectYear}>
                  {!_.isEmpty(listCourseBase) &&
                    listCourseBase.map((item) => (
                      <Option value={item.id} key={item.id}>
                        {item.description}
                      </Option>
                    ))}
                </StyleSelectCourse>
              </div>
            </div>
            <div>
              <label htmlFor="" className="font-bold mb-10 block">
                Quý
              </label>
              <div className="relative">
                <StyleSelectPeriod
                  mode="multiple"
                  style={{
                    width: 350,
                    height: 40,
                    position: 'relative'
                  }}
                  value={period}
                  tagRender={tagRender}
                  placeholder="Chọn quý"
                  onChange={onSelectPeriod}
                  dropdownStyle={{ width: '350' }}>
                  {!_.isEmpty(listPeriod.periods) &&
                    listPeriod.periods.map((item) => (
                      <Option value={item.id} key={item.id} title={item.title}>
                        {item.title}
                      </Option>
                    ))}
                </StyleSelectPeriod>
                <IconDropdown>
                  <DownOutlined />
                </IconDropdown>
              </div>
            </div>
          </div>
        </Card>
      </Container>
    </Modal>
  );
}

export default ModalCloneReview;
